import React, { Component } from "react";
import { useMap } from "react-leaflet";
import L, { LeafletMouseEvent, Map } from "leaflet";

class CenterButton extends Component {
  
  createButtonControl() {
    const CenterButton = L.Control.extend({
      onAdd: (map) => {
        const centerDiv = L.DomUtil.create("button", ""); 
        this.centerDiv = centerDiv;
        centerDiv.innerHTML = this.props.title;

        centerDiv.addEventListener("click",(e)=>{
            e.stopPropagation();
            map.locate().on("locationfound", function(e){
                map.flyTo(e.latlng,map.getZoom());
                const radius=e.accuracy;
                const circle=L.circle(e.latlng, radius);
                circle.addTo(map);
            });
        });
        
        return centerDiv;
      }
    });
    return new CenterButton({ position: "bottomleft" });
  }

  componentDidMount() {
    const { map } = this.props;
    const control = this.createButtonControl();
    control.addTo(map);
  }

  componentWillUnmount() {
    this.centerDiv.remove();
  }

  render() {
    return null;
  }
}


function withMap(Component) {
  return function WrappedComponent(props) {
    const map = useMap();
    return <Component {...props} map={map} />;
  };
}

export default withMap(CenterButton);